import React from "react";
import AdministrationApplications from "../../features/administrationapplications";

const ApplicationsManagementPage = () => <AdministrationApplications />

export default ApplicationsManagementPage;